import fromPairs from "lodash/fromPairs"
import map from "lodash/map"

export default function normalize(data, model) {
  const { primaryKey = `id` } = model

  /* Apply normalizer for whole collection */
  const selectData =
    model.collection && model.collection.normalize
      ? model.collection.normalize(data)
      : data

  const bindedData = fromPairs(
    map(selectData, item => [item[primaryKey], item]),
  )

  const mappedData = map(selectData, item => item[primaryKey])

  return {
    data: bindedData,
    result: mappedData,
  }
}
